import { postRequestWithApiKey } from "./API";
import { strings } from "../utils/constants";

export const logWebAccess = async (language = strings.language.EN, source = null) => {
    try {
        const accessData = {
            access_type: "web",
            language_preference: language,
            access_datetime: new Date().toISOString(),
            source: source || document.referrer || null
        };

        const cleanedAccessData = Object.fromEntries(
            Object.entries(accessData).filter(([, value]) => value !== null && value !== undefined)
        );

        const response = await postRequestWithApiKey(
            language,
            "accessLogs",
            cleanedAccessData,
            true
        );

        return response;
    } catch (error) {
        return null;
    }
};

// NOTE: The website intentionally does NOT create a "desktop" access log.
// The desktop application owns and creates the single desktop access log
// itself (with its own user/app info), using the source the website hands off
// through the formdepot://launch?source=... deep link. See
// src/services/source.js and src/pages/User/AccessADA/index.js.